import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Regexs } from '@utils/regex';

@Component({
  selector: 'app-informacion-empleados',
  templateUrl: './informacion-empleados.component.html',
  styleUrls: ['./informacion-empleados.component.scss'],
})
export class InformacionEmpleadosComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      codigo_usuario: [
        values ? values.codigo_usuario : '',
        [Validators.required],
      ],
      cedula: [
        values ? values.cedula : '',
        [Validators.required, Validators.pattern(Regexs.regexCiRif)],
      ],
      nombres_apellidos: [
        values ? values.nombres_apellidos : '',
        [Validators.required],
      ],
      cargo: [values ? values.cargo : '', [Validators.required]],
      departamento_agencia: [
        values ? values.departamento_agencia : '',
        [Validators.required],
      ],
      fecha_ingreso: [
        values ? values.fecha_ingreso : '',
        [Validators.required],
      ],
      fecha_egreso: [values ? values.fecha_egreso : '', [Validators.required]],
      fecha_activacion: [
        values ? values.fecha_activacion : '',
        [Validators.required],
      ],
      supervisor_inmediato: [
        values ? values.supervisor_inmediato : '',
        [Validators.required],
      ],
      estado: [values ? values.estado : '', [Validators.required]],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
